import {Component, OnInit, inject, input, effect, signal} from '@angular/core';
import {AdsService} from "../services/ads.service";
import {UserService} from "../../../core/user/services/user.service";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";
import {Ad} from "../models/ads.model";

@Component({
  selector: 'app-ads-skyscraper',
  templateUrl: './ads-skyscraper.component.html',
  styleUrl: './ads-skyscraper.component.scss'
})

export class AdsSkyscraperComponent implements  OnInit{
  protected adsService: AdsService = inject(AdsService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);
  protected PHXCDN = inject('PHXCDN' as any) as string;

  position = input<'left' | 'right'>();
  selected = signal<any>(null);

  constructor() {
    effect(() => {
      const allAds = this.position() === 'left'
        ? this.adsService.leftAds()
        : this.adsService.rightAds();

      if (allAds.length === 0) {
        this.selected.set(null);
        return;
      }

      const pool = this.buildPool(allAds);
      const current = this.selected();

      if (!current || !pool.some(a => a.id === current.id)) {
        this.selected.set(pool[Math.floor(Math.random() * pool.length)]);
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.pickNewAd();
    });
  }

  private pickNewAd(): void {
    const allAds = this.position() === 'left'
      ? this.adsService.leftAds()
      : this.adsService.rightAds();

    const pool = this.buildPool(allAds);
    if (pool.length === 0) return;

    const current = this.selected();

    if (current && pool.length > 1) {
      const candidates = pool.filter(a => a.id !== current.id);
      this.selected.set(candidates[Math.floor(Math.random() * candidates.length)]);
    } else if (!current) {
      this.selected.set(pool[Math.floor(Math.random() * pool.length)]);
    }
  }

  private buildPool(allAds: Ad[]): Ad[] {
    if (this.userService.isAdmin()) return allAds;
    const prio = allAds.filter(a => a.prioritized);
    return prio.length > 0 ? prio : allAds;
  }
}
